export const contentSectionGql = /* GraphQL */ `
    contentSection {
        ... on contentSections_Category {
            title
            breadcrumbLink {
                uri
            }
        }
    }
`;